import { useState, useEffect } from 'react';
import Api from 'entities/helpers/api';
import OrgStore from 'base/org/org-store';
import _ from 'underscore';

const useFetchTasksEmailAlertPrefs = (isModalOpen) => {
  const [alertPrefs, setAlertPrefs] = useState({});

  useEffect(() => {
    const fetchPrefs = async () => {
      try {
        const resp = await Api.EMS.PREFS.get({
          params: {
            key_pattern: `journeys:tasks:oid-${OrgStore.getCurrentOrg().id}:`,
          },
        });
        const prefs = Array.isArray(resp) ? resp : resp?.preferences || [];
        const alertPref = prefs.find((pref) => pref.oid === OrgStore.getCurrentOrg().id);
        if (!_.isEmpty(alertPref)) setAlertPrefs(alertPref);
      } catch {
        // EMS service may be unavailable (e.g. CORS in local dev)
      }
    };
    fetchPrefs();
  }, [isModalOpen]);

  return { alertPrefs };
};

export default useFetchTasksEmailAlertPrefs;
